import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { BotonTipo } from '../boton/boton';
import { VolverService } from '../../providers/volver.service';

@Component({
  selector: 'app-volver',
  templateUrl: './volver.component.html',
  styleUrls: ['./volver.component.scss']
})
export class VolverComponent {
  @Input() type: BotonTipo;
  @Input() tooltipDir: string = 'below';

  constructor(
    private location: Location,
    private volverSv: VolverService
  ) { }

  ngOnInit() {
    if (!this.type) {
      throw "La variable Input 'type' es requerida";
    }
  }

  volver() {
    // avisarle al sistema que hicieron click en volver
    VolverService.click_en_volver = true;
    // indicar que hicieron click en volver
    this.location.back();
  }

}
